<div style="text-align:center">
  <img *ngIf="url != ''" src="{{url}}" />
</div>
